export default function Cross({ color = '#EC5E49' }) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3335 11.3335L20.6668 20.6668L11.3335 11.3335Z" fill={color} />
            <path d="M11.3335 11.3335L20.6668 20.6668" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.6668 11.3335L11.3335 20.6668L20.6668 11.3335Z" fill={color} />
            <path d="M20.6668 11.3335L11.3335 20.6668" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}